import {useMemo} from 'react';

import {analyzeListing} from './seoChecks';

/**
 * React hook that provides memoized SEO analysis for a listing.
 * @param {Object} listing — listing with fields
 * @param {Object[]} vars — product variables [{name, sample}]
 */
export function useSeoAnalysis(listing, vars = [], brandProfile = null) {
    const depKey = useMemo(() => {
        if (!listing?.fields) return '';
        const fieldKey = listing.fields
            .map((f) => `${f.id}:${f.text}:${(f.searchTerms || []).join(',')}`)
            .join('|');
        const varKey = vars.map((v) => `${v.name}:${v.sample}`).join('|');
        const brandKey = brandProfile?.companyName || '';
        return `${fieldKey}::${varKey}::${brandKey}`;
    }, [listing, vars, brandProfile]);

    const analysis = useMemo(() => {
        if (!listing?.fields?.length) return null;
        return analyzeListing(listing, vars, brandProfile);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [depKey]);

    return analysis;
}
